import { render, staticRenderFns } from "./myProfile.vue?vue&type=template&id=40a77528&scoped=true"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"
import style0 from "./myProfile.vue?vue&type=style&index=0&id=40a77528&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a77528",
  null
  
)

export default component.exports